$(window).on('load', function() {

  var countrySelect = $('select[name=\'shippingCountrySelect\']');
  var rateContainer = $('#rate-container');

  countrySelect.on('change', function() {

    var shippingRates = theme.allShippingRates[this.value];
    var country = this.options[this.selectedIndex].text;

    var html;

    html  = '<div class="scrollable-wrapper">';
    html += '<table width="100%">';
    html += '  <thead>';
    html += '    <tr>';
    html += '      <th colspan="3" class="text-center">Shipping costs to ' + country + '</th>';
    html += '    </tr>';
    html += '  </thead>';
    html += '  <tbody>';

	if (typeof shippingRates === "undefined" || shippingRates.length == 0) {
        html += '    <tr>';
        html += '      <td colspan="3">No shipping costs for ' + country + '.</td>';
        html += '    </tr>';
    } else {
      for (let i = 0, l = shippingRates.length; i < l; i++) {

        var carrierImage = "\/\/riodesal.shop\/cdn\/shop\/t\/2\/assets\/shipping-carrier.png?v=17250";
        
        if (shippingRates[i].price == 0) {
          var ratePrice = '<strong>Kostenloser Versand</strong>';
        } else {
          var ratePrice = theme.Currency.formatMoney(shippingRates[i].price, theme.moneyFormat);
        }

        html += '    <tr>';
        html += '      <td class="text-center" style="width: 144px; min-height: 85px;">';
        html += '        <img src="' + carrierImage.replace('carrier', shippingRates[i].code) + '" style="max-width: 115px; min-height: 58px;" width="115">';
        html += '      </td>';
        html += '      <td class="text-center">';
        html += '        <p>' + shippingRates[i].name + '</p>';

        if (shippingRates[i].description != '') {
          html += '      <p>' + shippingRates[i].description + '</p>';
        }
        
        html += '      </td>';
        html += '      <td>';
        if (shippingRates[i].free_over == '') {
          html += '        <p style="white-space: nowrap;">' + ratePrice + '</p>';
        } else {
          html += '        <p style="white-space: nowrap;">' + ratePrice + '<br /><strong>' + "Kostenloser Versand für Bestellungen über #price#".replace('#price#', theme.Currency.formatMoney(shippingRates[i].free_over, theme.moneyFormat)) + '</strong></p>';
        }
        html += '      </td>';
        html += '    </tr>';
      }
    }

    html += '  </tbody>';
    html += '</table>';
    html += '</div>';

    rateContainer.html(html);
  });

  document.addEventListener("BBSGeoipLoaded", function (event) {
    countrySelect.val(event.detail.country_code);
    countrySelect.trigger('change');
  });
});